import { render, staticRenderFns } from "./veJkyMeetMy.vue?vue&type=template&id=f96547ee"
import script from "./veJkyMeetMy.vue?vue&type=script&lang=js"
export * from "./veJkyMeetMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports